import { useInfiniteQuery } from '@tanstack/vue-query'
import { propertyKeys } from './propertyQueryKeys'
import { getProperties } from './propertyEndpoints'
import { parsePropertyList } from './propertyParser'
import { PROPERTIES_PAGE_LIMIT } from '../constants/propertyLifecycle'
import type { PropertyListPage } from '../types/propertyTypes'

// Paginated list of the seller's promoted properties. Accumulates pages via
// useInfiniteQuery (card list + "Load more"), matching the Sell Request ledger.
// No filter argument — the endpoint offers no stage filter by design.
//
// The key is a plain array, not a getter: there are no reactive params to track,
// and this version of @tanstack/vue-query does not accept a getter for `queryKey`
// (which is why the page callbacks would otherwise infer `unknown`).
export function usePropertiesQuery() {
  return useInfiniteQuery({
    queryKey: propertyKeys.list(),
    queryFn: ({ pageParam }): Promise<PropertyListPage> =>
      getProperties({ page: pageParam, limit: PROPERTIES_PAGE_LIMIT }).then(parsePropertyList),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) =>
      allPages.length < lastPage.pagination.totalPages ? allPages.length + 1 : undefined,
  })
}
